export default { 
  adminTypeTrade (state) {
    return state.adminTypeTrade
  },
  adminWallet (state) {
    return state.adminWallet
  }
}